import { isEmpty } from '@/utils/is';
import { getPosition } from '../utils/filter';

export default {
  data() {
    return {
      byDeviceType: [
        'deviceTypeName',
        'dynamicInfoMap',
        'state',
        'col2_dynamicInfoMap',
        'col2_state'
      ],
      byPlace: ['dynamicInfoMap', 'deviceTypeName', 'state', 'col2_deviceTypeName', 'col2_state']
    };
  },
  methods: {
    makeDeviceTypeColumn(flag) {
      return (
        <el-table-column
          prop="deviceTypeName"
          key={flag ? 'col2_deviceTypeName' : 'deviceTypeName'}
          label={`${this.$t('设备')}${flag ? '2' : ''}`}
          render-header={() => (
            <div class="col-flex">
              <img src="/static/image/device/device-icon.png" alt="" />
              <span>{this.$t('设备')}</span>
            </div>
          )}
          align="center"
          min-width={this.deviceMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 : row;

            const prop = this.isGroupByPlace ? 'name' : 'deviceTypeName';

            if (r) {
              const text = r[prop];

              const snText = this.isGroupByPlace ? `(${r.sn})` : '';

              const fullText = `${text}${snText}`;

              const formatter = () => {
                return fullText;
              };

              return <Col key={r.sn} device={r} formatter={formatter} is-inline={this.isInline} />;
            } else {
              return <span></span>;
            }
          }}
        </el-table-column>
      );
    },
    makePositionColumn(flag) {
      return (
        <el-table-column
          prop="dynamicInfoMap"
          label={`${this.$t('位置')}${flag ? '2' : ''}`}
          render-header={() => (
            <div class="col-flex">
              <img src="/static/image/device/position-icon.png" alt="" />
              <span>{this.$t('位置')}</span>
            </div>
          )}
          align="center"
          min-width={this.positionMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 || {} : row;

            if (isEmpty(r)) return <span></span>;

            const posText = getPosition(
              r.dynamicInfoMap,
              this.isGroupByPlace ? this.$t('其他') : r.name || r.sn
            );

            const snText = !this.isGroupByPlace ? `(${r.sn})` : '';

            const fullText = `${posText}${snText}`;

            return <MultiLineText text={fullText} id={`sn-${r.sn}`} share-out={true} />;
          }}
        </el-table-column>
      );
    },
    makeStateColumns(flag) {
      const texts = ['正常', '故障', '报警'];
      const makeItem = (text, ind) => (
        <el-table-column
          class-name="state-col"
          prop="state"
          label={this.$t(text)}
          align="center"
          width={this.stateMinWidth}
        >
          {({ row }) => {
            const r = flag ? row.col2 : row;

            return (
              r && (
                <StateIcon
                  value={r}
                  onDisposition={() => {
                    if (ind !== 2) return;

                    this.handleAlarmIconClick(r);
                  }}
                  state={ind}
                />
              )
            );
          }}
        </el-table-column>
      );

      return texts.map((e, i) => makeItem(e, i));
    },
    getColumns() {
      const dict = {
        deviceTypeName: () => this.makeDeviceTypeColumn(),
        dynamicInfoMap: () => this.makePositionColumn(),
        state: () => this.makeStateColumns(),
        col2_dynamicInfoMap: () => this.makePositionColumn(true),
        col2_deviceTypeName: () => this.makeDeviceTypeColumn(true),
        col2_state: () => this.makeStateColumns(true)
      };

      const len = this.isInline ? 3 : 5;

      if (this.isGroupByPlace) {
        const res = this.byPlace
          .slice(0, len)
          .map(e => dict[e]?.())
          .flat();

        return res;
      } else {
        return this.byDeviceType
          .slice(0, len)
          .map(e => dict[e]?.())
          .flat();
      }
    }
  },
  render() {
    const { title, tableConfig } = this;

    return (
      <div ref="container" class="device-monitor_list">
        <div class="title">{title}</div>
        <el-table
          key={`${+this.isGroupByPlace}-${+this.isInline}`}
          class="subway-table"
          ref="table"
          height="calc(100% - var(--font-size) * 1.35 - 88px)"
          style="width: 100%"
          gutter-width={12}
          border
          data={tableConfig.data}
          span-method={this.spanHandler}
          on-row-contextmenu={this.handleRightClick}
        >
          {this.getColumns()}
        </el-table>

        <MultiAlarm ref="multiAlarm" />
        <SingleAlarm ref="singleAlarm" />
      </div>
    );
  }
};

// <template>
//   <div ref="container" class="device-monitor_list">
//     <div class="title">{{ title }}</div>
//     <el-table
//       class="subway-table"
//       ref="table"
//       height="calc(100% - var(--font-size) * 1.35 - 88px)"
//       style="width: 100%"
//       border
//       :data="tableConfig.data"
//       :span-method="spanHandler"
//       @row-contextmenu="handleRightClick"
//     >
//       <el-table-column
//         prop="deviceTypeName"
//         :label="'设备' | translateTo('monitor.thead')"
//         align="center"
//         :min-width="deviceMinWidth"
//       >
//         <template #header="{ column }">
//           <div class="col-flex">
//             <img src="/static/image/device/device-icon.png" alt="" />
//             <span>{{ column.label }}</span>
//           </div>
//         </template>
//         <template #default="{ row }">
//           <Col :device="row" :is-inline="isInline" />
//         </template>
//       </el-table-column>
//       <el-table-column
//         prop="dynamicInfoMap"
//         :label="'位置' | translateTo('monitor.thead')"
//         align="center"
//         :min-width="positionMinWidth"
//       >
//         <template #header="{ column }">
//           <div class="col-flex">
//             <img src="/static/image/device/position-icon.png" alt="" />
//             <span>{{ column.label }}</span>
//           </div>
//         </template>
//         <template #default="{ row }">
//           <MultiLineText
//             :text="getPosition(row.dynamicInfoMap) || row.name"
//             :id="`sn-${row.sn}`"
//             :share-out="true"
//           />
//         </template>
//       </el-table-column>
//       <el-table-column
//         class-name="state-col"
//         prop="state"
//         :label="'正常' | translateTo('monitor.thead')"
//         align="center"
//         :width="stateMinWidth"
//       >
//         <template #default="{ row }">
//           <StateIcon :value="row" :state="0" />
//         </template>
//       </el-table-column>
//       <el-table-column
//         class-name="state-col"
//         prop="state"
//         :label="'故障' | translateTo('monitor.thead')"
//         align="center"
//         :width="stateMinWidth"
//       >
//         <template #default="{ row }">
//           <StateIcon :value="row" :state="1" />
//         </template>
//       </el-table-column>
//       <el-table-column
//         class-name="state-col"
//         prop="state"
//         :label="'报警' | translateTo('monitor.thead')"
//         align="center"
//         :width="stateMinWidth"
//       >
//         <template #default="{ row }">
//           <StateIcon :value="row" @disposition="handleAlarmIconClick(row)" :state="2" />
//         </template>
//       </el-table-column>
//       <template v-if="multiColumn">
//         <el-table-column
//           prop="col2"
//           :label="'位置' | translateTo('monitor.thead')"
//           align="center"
//           :min-width="positionMinWidth"
//         >
//           <template #header="{ column }">
//             <div class="col-flex">
//               <img src="/static/image/device/position-icon.png" alt="" />
//               <span>{{ column.label }}</span>
//             </div>
//           </template>
//           <template #default="{ row }">
//             <MultiLineText
//               v-if="row.col2"
//               :text="getPosition(row.col2.dynamicInfoMap) || row.col2.name"
//               :id="`sn-${row.col2.sn}`"
//               :share-out="true"
//             />
//           </template>
//         </el-table-column>
//         <el-table-column
//           class-name="state-col"
//           prop="col2"
//           :label="'正常' | translateTo('monitor.thead')"
//           align="center"
//           :width="stateMinWidth"
//         >
//           <template #default="{ row }">
//             <StateIcon v-if="row.col2" :value="row.col2" :state="0" />
//           </template>
//         </el-table-column>
//         <el-table-column
//           class-name="state-col"
//           prop="col2"
//           :label="'故障' | translateTo('monitor.thead')"
//           align="center"
//           :width="stateMinWidth"
//         >
//           <template #default="{ row }">
//             <StateIcon v-if="row.col2" :value="row.col2" :state="1" />
//           </template>
//         </el-table-column>
//         <el-table-column
//           class-name="state-col"
//           prop="col2"
//           :label="'报警' | translateTo('monitor.thead')"
//           align="center"
//           :width="stateMinWidth"
//         >
//           <template #default="{ row }">
//             <StateIcon
//               v-if="row.col2"
//               :value="row.col2"
//               @disposition="handleAlarmIconClick(row.col2)"
//               :state="2"
//             />
//           </template>
//         </el-table-column>
//       </template>
//     </el-table>
//     <MultiAlarm ref="multiAlarm" />
//     <SingleAlarm ref="singleAlarm" />
//   </div>
// </template>
